type GroupedItems = Record<string, string[]>;

type Props = {
	groupedItems: GroupedItems;
};

export const setSortedGroups = ({ groupedItems }: Props) =>
	Object.keys(groupedItems)
		.sort((a, b) => {
			if (a === 'Overig') return 1;
			if (b === 'Overig') return -1;
			return a.localeCompare(b);
		})
		.map((group) => ({
			group,
			items: groupedItems[group].sort(),
		}));
